import React, { Component } from "react";
import "./Subagents.css";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import EmptyImage from "../../assets/images/Empty.png";
import { Base64 } from "js-base64";

import {
  getSubagentBookingDetails,
} from "../axios";
import Skeleton from "react-loading-skeleton";
import moment from "moment";


class Subagents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Agent: true,
      ChangeColor: "reviewPlanned",
      ChangeColorNew: "tripStatusContainer reviewPlannedNew",
      agentData: null,
      subAgentData: null,
    };
  }


  componentDidMount() {
    this.setState({ Agent: true });
    this.setState({ ChangeColor: "reviewUpcoming" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewUpcomingNew" });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const subagent_uid = urlParams.get("subagentid");
       const subAgentid =  Base64.atob(subagent_uid);
   
    getSubagentBookingDetails(subAgentid).then(
      (data) => {
        this.setState({ subAgentData: data });
      },
      (error) => {}
    );
    
  }

  render() {
    return (
      <div>
        <Helmet>
          <title> Sub Agent @ Holiday Seychelles</title>
          <meta
            name="description"
            content="Plan your honeymoon in one of the beautiful places in the world - Holiday Seychelles."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          {" "}
          Sub Agent @ Holiday Seychelles
        </h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div className={this.state.ChangeColor} style={{ marginTop: "-5px" }}>
            <div className="landingContainer">
              {/* <h4>Booking Report</h4> */}
            </div>

          </div>

          <div className={this.state.ChangeColorNew}>
            <div className="tripStatusWrap">
              <ul>
                <li
                  className={this.state.Agent && "active ColorUpcoming"}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                      Booking Report
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
               
              </ul>
              <div className="txtFild "></div>
            </div>
          </div>
          <div className="contentWrapper myTrips">
            <div>
              <div className="tripListingWrap">
                <div>
                 
                  {this.state.Agent == true ? (
                    <div className="myTripLstngLobCrd forUpcoming">
                      {this.state.subAgentData == "" ? (
                        <div className="emptyErr">
                          <div className="emptyErr--imgCont">
                            <img src={EmptyImage} alt="Upcoming Image" />
                          </div>
                          <div>
                            <p className="emptyErr--heading font22 latoBlack appendBottom15">
                              Looks empty, you've no sub agent booking .
                            </p>
                            <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                              When you save your sub agent booking, you will see booking here
                              here.
                            </p>
                            <p style={{margin: 10}}>
                              <a href="/home">
                                <button className="font14 latoBold blueText myTripBtn myTripBtn--primary ">
                                  Home
                                </button>
                              </a>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                          {this.state.subAgentData == null ? (
                            <>
                              <div
                                className="Container-TileUser"
                                style={{ height: 250 }}
                              >
                                <div className="ContainerFlex">
                                  <div
                                    className="ContainerImage"
                                    style={{ padding: "15px 10px 10px 10px" }}
                                  >
                                    <Skeleton
                                      style={{ width: "100%", height: "165px" }}
                                    />
                                  </div>
                                  <div
                                    className="ContainerContent"
                                    style={{ padding: "10px 10px 10px 40px" }}
                                  >
                                    <div
                                      className="nameContainer"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="paymakeFlex appendBottom5">
                                        <h3 className="latoBlack font22 blackText">
                                          <Skeleton
                                            style={{ width: "200px" }}
                                          />
                                        </h3>
                                        <span
                                          className="sRating"
                                          style={{
                                            display: "inline-flex",
                                            marginTop: "5px",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <Skeleton
                                            style={{ width: "100px" }}
                                          />
                                        </span>
                                      </div>
                                      <p>
                                        <Skeleton style={{ width: "300px" }} />
                                      </p>
                                      <h3
                                        className="latoBlack font22 blackText"
                                        style={{
                                          marginTop: 10,
                                          fontSize: 18,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <Skeleton style={{ width: "150px" }} />
                                      </h3>

                                      <div class="chkContBooking">
                                        <div class="chkCont__col">
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText 444">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="chkCont__night">
                                            <span>
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="Container-TileUser">
                                <div className="ContainerFlex">
                                  <div class="container">
                                    <div class="row">
                                      <div>
                                         <table className="table table-bordered">
                                          <thead className="thead-dark">
                                            <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">Booking Ref ID</th>
                                              <th scope="col">Subagent Name</th>
                                              <th scope="col">Total Amount</th>
                                              <th scope="col">Net Amount</th>
                                              <th scope="col">Booking Date</th>
                                              <th scope="col">Service Date</th>
                                              <th scope="col">Commission(%)</th>
                                              <th scope="col">Commission(EURO)</th>
                                              <th scope="col">Status</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                          {this.state.subAgentData &&
                                              this.state.subAgentData.map(
                                                (item, newindex) => {
                                                let totalAmount =  parseFloat(item?.total_value.slice(5,13));
                                                 let agent_price_percentage = (item?.agent_percentage);
                                                 let agent_price_new =  ((totalAmount*agent_price_percentage)/100);
                                                 let NetAmount =  (totalAmount-agent_price_new);
                                                 let subAgentPercentage =  item?.sub_agent_commission;
                                                 let subagentAmount =  (NetAmount*subAgentPercentage)/100;
                                                  return(
                                                <tr>
                                                  <th scope="row">{newindex+1}</th>
                                                  <td>{item?.booking_refrence_id}</td>
                                                  <td>{item?.subagent_name}</td>
                                                  <td>{item?.total_value}</td>
                                                  <td>{NetAmount.toFixed(2)}</td>
                                                  <td>{moment(item?.booking_date).format("D MMM Y")}</td>
                                                  <td>{moment(item?.service_date).format("D MMM Y")}</td>
                                                  <td>{item?.sub_agent_commission}</td>
                                                  <td>{subagentAmount.toFixed(2)}</td>
                                                  <td>{item?.agent_subagent_status ==1?'Paid':'Unpaid'}</td>
                                                </tr>
                                                )})}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Subagents;
